<template>
    <div id="shipIndexScroll" ref="shipIndexPage">
        <!--==== banner ====-->
        <div class="shipIndex-banner">
            <img src="https://resource.rcclchina.com.cn/mobileShip/banner.jpg" alt="皇家船队" />
        </div>
        <!--==== carousel ====-->
        <div class="shipIndex-carousel">
            <!-- Swiper -->
            <div class="swiper-container">
                <div class="swiper-wrapper">
                    <!-- 每三个为一组 通过data-index来切换内容-->
                    <div class="swiper-slide">
                        <div class="swiper-slideDiv" @click="changeMode('hp')">
                            <img src="https://resource.rcclchina.com.cn/0/0307/SH1.jpg" alt="中国出发" />
                            <div class="swiper-slide-content" :class="{ active: mode == 'hp'}">
                                <span>中国出发</span>
                            </div>
                        </div>
                        <div class="swiper-slideDiv" @click="changeMode('row')">
                            <img src="https://resource.rcclchina.com.cn/symphony/abroad.jpg" alt="海外出发" />
                            <div class="swiper-slide-content" :class="{ active: mode == 'row'}">
                                <span>海外出发</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--==== ship ====-->
        <div class="shipIndex-ship" v-show="mode=='hp'">
            <div class="shipIndex-ship-itemTitle">
                <span class="shipIndex-ship-itemTxt">中国出发</span>
                <div class="shipIndex-ship-itemLines"></div>
            </div>

            <ShipIndexItem 
            v-for="ship in ships.hp" :key="ship.shipCode"
            :ship="ship"
            :isRow="false"
            />

        </div>
        <div class="shipIndex-ship" v-show="mode=='row'">
            <div class="shipIndex-ship-itemTitle">
                <span class="shipIndex-ship-itemTxt">海外出发</span>
                <div class="shipIndex-ship-itemLines"></div>
            </div>

            <ShipIndexItem 
            v-for="ship in ships.row" :key="ship.shipCode"
            :ship="ship"
            :isRow="true"
            />

        </div>

        <div class="shipIndex-fixMenu" v-show="isShowFixedMenu">
            <div class="shipIndex-fixMenu-item" style="width: 50%;" 
            @click="changeMode('hp')" :class="{ active: mode == 'hp'}">
                <div class="shipIndex-fixMenu-itemTxt" :class="{ active: mode == 'hp'}">中国出发</div>
            </div>
            <div class="shipIndex-fixMenu-item" style="width: 50%;" 
            @click="changeMode('row')" :class="{ active: mode == 'row'}">
                <div class="shipIndex-fixMenu-itemTxt" >海外出发</div>
            </div>
        </div>
    </div>
</template>

<script>
const ShipIndexItem = () => import('@/components/Ship/ShipIndexItem')
export default {
    name: "ShipIndex",
    components: {
        ShipIndexItem
    },
    data () {
        return {
            mode: "hp",
            isShowFixedMenu: false,
            ships: {
                hp: [
                    {
                        "shipCNName": "海洋光谱号",
                        "shipCode": "SC",
                        "shipENName": "Spectrum of the Seas",
                        "departure": "上海/香港",
                        "capacity": "5,549",
                        "weight": "168,666",
                        "link": "/content/taste/ships/SC",
                        "vrLink": "",
                        "image": "https://resource.rcclchina.com.cn/SC/sc1459X552%20(1).jpg"
                    },
                    {
                        "shipCNName": "海洋量子号",
                        "shipCode": "QN",
                        "shipENName": "Quantum of the Seas",
                        "departure": "天津/香港",
                        "capacity": "4,905",
                        "weight": "168,000",
                        "link": "/content/taste/ships/QN",
                        "vrLink": "https://www.rcclchina.com.cn/campaign/qnvr/lzvtour/tour.html",
                        "image": "https://resource.rcclchina.com.cn/Ship/shipPage/QN.jpg"
                    },
                    {
                        "shipCNName": "海洋航行者号",
                        "shipCode": "VY",
                        "shipENName": "Voyager of the Seas",
                        "departure": "香港",
                        "capacity": "4,269",
                        "weight": "138,000",
                        "link": "/content/taste/ships/VY",
                        "vrLink": "",
                        "image": "https://resource.rcclchina.com.cn/MobileShipImage/shipImg3.jpg"
                    },
                ],
                row: [
                    {
                        "shipCNName": "海洋交响号",
                        "shipENName": "Symphony of the Seas",
                        "departure": "加勒比航线",
                        "image": "https://resource.rcclchina.com.cn/Ship/shipPage/SY.jpg",
                        "link": "https://mobile.rclrow.com/Cruise/MobileSearch?shipCodes=SY",
                        "capacity": "6,680",
                        "weight": "225,000",
                        "shipCode": "SY"
                    },
                    {
                        "shipCNName": "海洋和悦号",
                        "shipENName": "Harmony of the Seas",
                        "departure": "加勒比航线",
                        "image": "https://resource.rcclchina.com.cn/Ship/shipPage/HM.jpg",
                        "link": "https://mobile.rclrow.com/Cruise/MobileSearch?shipCodes=HM",
                        "capacity": "7,029",
                        "weight": "225,000",
                        "shipCode": "HM"
                    },
                    {
                        "shipCNName": "海洋魅力号",
                        "shipENName": "Allure of the Seas",
                        "departure": "加勒比/欧洲航线",
                        "image": "https://resource.rcclchina.com.cn/Ship/shipPage/AL.jpg",
                        "link": "https://mobile.rclrow.com/Cruise/MobileSearch?shipCodes=AL",
                        "capacity": "6,780",
                        "weight": "225,000",
                        "shipCode": "AL"
                    },
                    {
                        "shipCNName": "海洋绿洲号",
                        "shipENName": "Oasis of the Seass",
                        "departure": "加勒比/欧洲航线",
                        "image": "https://resource.rcclchina.com.cn/Ship/shipPage/OA.jpg",
                        "link": "https://mobile.rclrow.com/Cruise/MobileSearch?shipCodes=OA",
                        "capacity": "6,780",
                        "weight": "225,000",
                        "shipCode": "OA"
                    },
                    {
                        "shipCNName": "海洋量子号",
                        "shipENName": "Quantum of the Seas",
                        "departure": "新加坡航线",
                        "image": "https://resource.rcclchina.com.cn/Ship/shipPage/QN.jpg",
                        "link": "https://mobile.rclrow.com/Cruise/MobileSearch?shipCodes=QN",
                        "capacity": "4,905",
                        "weight": "168,000",
                        "shipCode": "QN"
                    },
                    {
                        "shipCNName": "海洋赞礼号",
                        "shipENName": "Ovation of the Seas",
                        "departure": "阿拉斯加/澳新航线",
                        "image": "https://resource.rcclchina.com.cn/Ship/shipPage/OV.jpg",
                        "link": "https://mobile.rclrow.com/Cruise/MobileSearch?shipCodes=OV",
                        "capacity": "4,905",
                        "weight": "168,000",
                        "shipCode": "OV"
                    },
                    {
                        "shipCNName": "海洋航行者号",
                        "shipENName": "Voyager of the Seas",
                        "departure": "新加坡/澳新航线",
                        "image": "https://resource.rcclchina.com.cn/Ship/shipPage/VY.jpg",
                        "link": "https://mobile.rclrow.com/Cruise/MobileSearch?shipCodes=VY",
                        "capacity": "4,269",
                        "weight": "138,000",
                        "shipCode": "VY"
                    },
                    {
                        "shipCNName": "海洋水手号",
                        "shipENName": "Mariner of the Seas",
                        "departure": "加勒比航线",
                        "image": "https://resource.rcclchina.com.cn/Ship/shipPage/MA.jpg",
                        "link": "https://mobile.rclrow.com/Cruise/MobileSearch?shipCodes=MA",
                        "capacity": "4,000",
                        "weight": "138,000",
                        "shipCode": "MA"
                    },
                    {
                        "shipCNName": "海洋探险者号",
                        "shipENName": "Explorer of the Seas",
                        "departure": "欧洲航线",
                        "image": "https://resource.rcclchina.com.cn/Ship/shipPage/EX.jpg",
                        "link": "https://mobile.rclrow.com/Cruise/MobileSearch?shipCodes=EX",
                        "capacity": "4,290",
                        "weight": "138,000",
                        "shipCode": "EX"
                    },
                    {
                        "shipCNName": "海洋珠宝号",
                        "shipENName": "Jewel of the Seas",
                        "departure": "欧洲航线",
                        "image": "https://resource.rcclchina.com.cn/Ship/shipPage/JW.jpg",
                        "link": "https://mobile.rclrow.com/Cruise/MobileSearch?shipCodes=JW",
                        "capacity": "2,702",
                        "weight": "90,000",
                        "shipCode": "JW"
                    },
                    {
                        "shipCNName": "海洋灿烂号",
                        "shipENName": "Radiance of the Seas",
                        "departure": "阿拉斯加/澳新航线",
                        "image": "https://resource.rcclchina.com.cn/Ship/shipPage/RD.jpg",
                        "link": "https://mobile.rclrow.com/Cruise/MobileSearch?shipCodes=RD",
                        "capacity": "2,466",
                        "weight": "90,000",
                        "shipCode": "RD"
                    },
                    {
                        "shipCNName": "海洋迎风号",
                        "shipENName": "Rhapsody of the seas",
                        "departure": "欧洲航线",
                        "image": "https://resource.rcclchina.com.cn/Ship/shipPage/RH.jpg",
                        "link": "https://mobile.rclrow.com/Cruise/MobileSearch?shipCodes=RH",
                        "capacity": "2,416",
                        "weight": "78,000",
                        "shipCode": "RH"
                    }
                ]
            }
        }
    },
    beforeMount () {
        this.$store.commit('SET_PAGE_TITLE', '皇家船队')
        window.addEventListener("scroll", this.scrollHandler)
    },
    beforeDestroy () {
        window.removeEventListener("scroll", this.scrollHandler)
    },
    methods: {
        changeMode (mode) {
            this.mode = mode
            setTimeout(()=> {
                window.scroll({
                    top: mode == 'row' ? 223: 106, 
                    behavior: 'smooth'
                })
            }, 100)
        },
        scrollHandler () {
            const scrollTop = window.scrollY
            // console.log(scrollTop)
            if (scrollTop >= 223) {
                this.isShowFixedMenu = true
            } else {
                this.isShowFixedMenu = false
            }
        }
    }
}
</script>

<style lang="less" scoped>
/*
    ============ 船队页面 ============
    border-color:#eee;
*/

#shipIndexScroll {
    background-color:#fff;
    padding-bottom:88px;
}
/**** banner ****/
.shipIndex-banner {
    width:375px;
    height:187.5px;
}
.shipIndex-banner img{
    width:100%;
}
/**** carousel ****/
.shipIndex-carousel {
    padding:0 12px;
    margin-top:-37px;
}
.swiper-container {
    padding-bottom:0;
}
.swiper-slide {    
    height: 120px;
    overflow:hidden;
}
.swiper-slide > div {
    float: left;
    height: 120px;
    position:relative;
    width: 50%;
}
.swiper-slide img {
    width: 100%;
}
.swiper-slide-content {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,.6);
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
}
.swiper-slide-content span{
    font-size:12px;
    color:#fff;
    width:57px;
    text-align:center;
    display:inline-block;
    text-align:center;
    letter-spacing:1px;
}
.swiper-slide-content.active {
    background-color: rgba(240,175,17,.7);
}
.swiper-slide-content.active span {
    font-size: 15px;
    color: #061556;
    font-weight:bolder;
    width:100%;
    padding:0 10px;
}
.swiper-button-prev {
    background: url('https://resource.rcclchina.com.cn/mobileShip/carouselLeftArrow.png') no-repeat !important;
    top: 48%;
    width:11px;
}
.swiper-button-next {
    background: url('https://resource.rcclchina.com.cn/mobileShip/carouselRightArrow.png') no-repeat !important;
    top: 48%;
    width: 11px;
    transform: rotate(180deg);
    -webkit-transform: rotate(180deg);
    -moz-transform: rotate(180deg);
    -o-transform: rotate(180deg);
}

.shipIndex-ship {
    padding:0 12px;
    margin-top:25px;
    padding-bottom:15px;
}

.shipIndex-ship-itemTitle {
    position: relative;
    text-align: center;
}

.shipIndex-ship-itemTxt {
    font-size: 13px;
    color: #061556;
    padding: 0 7px;
    background-color: #fff;
    position: relative;
    z-index: 2;
}

.shipIndex-ship-itemLines {
    width: 100%;
    position: absolute;
    top: 12px;
    background-color: #f0af11;
    height: 1px;
}
/**** ship fix menu ****/
.shipIndex-fixMenu {
    position: fixed;
    top: 44px;
    left: 0;
    width: 100%;
    background-color: #f2f2f2;
    z-index:66;
}
.shipIndex-fixMenu-item {
    padding: 11px 0;
    width: 25%;
    line-height: 31px;
    text-align: center;
    display: inline-block;
    margin-left:-6px;
}
.shipIndex-fixMenu-item.active {
    background-color: #f0af11;
}
.shipIndex-fixMenu-item.active .shipIndex-fixMenu-itemTxt {
    color: #061556;
    font-size: 13px;
    border-right: 1px solid #f0af11;
}
.shipIndex-fixMenu-itemTxt {
    border-right: 1px solid #8b8b8b;
    color: #666;
    font-size:11px;
}
.shipIndex-fixMenu-item:last-child .shipIndex-fixMenu-itemTxt {
    border: none !important;
}
</style>